import approve from 'approvejs';

import Autogrow from 'textarea-autogrow';

import Component from '../base/component';

import { toggleClass } from '../base/dom-utils';

class Field extends Component {

    constructor(el, opts) {
        super(el, opts);

        this.checkIsDirty = this.checkIsDirty.bind(this);

        // magic if textarea
        if (this.$el.type && this.$el.type === 'textarea') {
            new Autogrow(this.$el);
        }
    }

    beforeInit() {
        this.$el.addEventListener('focusout', this.checkIsDirty, false);
        this.on('change:isDirty', (isDirty) => toggleClass(this.$el, this.options.dirtyClass, isDirty));
    }

    checkIsDirty() {
        const hasValue = this.$el.value.length;
        this.setState('isDirty', hasValue);
    }

    init() {
        // yes, set focus on new field
        //setTimeout( () => this.$el.focus(), 400);

        return super.init();
    }

    validateField() {

        const type = this.options.type;
        const currentValue = this.$el.value;

        if (type.length) {

            const result = approve.value(currentValue, {[type]: true});
            this.setState('errors', result.errors);

            return result.approved;

        }

        return true;

    }

    getInitialState() {
        return {
            isDirty: false,
            errors: []
        };
    }

    getDefaultOptions() {
        return {
            dirtyClass: 'is-dirty',
            type: undefined
        };
    }

    destroy() {
        this.$el.removeEventListener('focusout', this.checkIsDirty);
        return super.destroy();
    }
}

export default Field;


/** WEBPACK FOOTER **
 ** ./components/field.js
 **/